import { computed } from "vue";
import { formatDimension } from "@spoferan/spoferan-ts-core";
import { useNuxtApp } from "#app";
export function useTableComponent(props) {
  const { $breakpoint } = useNuxtApp();
  const displayHeaders = computed(() => {
    let headers = [...props.headers];
    if (displayWithMobileExpand.value) {
      const maxWidthFactor = $breakpoint.xsOnly ? 8 : 12;
      const mobileHeaders = [];
      let widthFactorSum = 0;
      headers.forEach((header) => {
        widthFactorSum += header.width_factor ?? (header.width ? Math.round(header.width / 50) : 1);
        if (widthFactorSum <= maxWidthFactor) {
          mobileHeaders.push(header);
        }
      });
      headers = mobileHeaders;
    }
    const withActionsHeader = props.withActions && headers.length && !headers.find((header) => header.value === "actions");
    if ((props.subRowsProp || props.subRowsExistenceProp || displayWithMobileExpand.value) && (!headers.length || headers[0].value !== "expand")) {
      if (withActionsHeader) {
        headers.splice(0, 0, { value: "expand", sortable: false, filterable: false });
      } else {
        headers.push({ value: "expand", sortable: false, filterable: false });
      }
    }
    if (withActionsHeader) {
      headers.push({ value: "actions", sortable: false, filterable: false, align: "center", width: 44, sticky: "right" });
    }
    return headers;
  });
  const displayWithMobileExpand = computed(() => {
    return props.expandOnMobile && $breakpoint.smAndDown;
  });
  const tableMaxHeightStyle = computed(() => {
    if (props.maxHeight) {
      return formatDimension(props.maxHeight);
    }
    return props.fixedHeader && $breakpoint.mdAndUp ? "80vh" : null;
  });
  function hasSubRows(row) {
    return !!(props.subRowsProp && row[props.subRowsProp] || props.subRowsExistenceProp && row[props.subRowsExistenceProp]);
  }
  function canBeExpanded(row) {
    return displayWithMobileExpand.value || hasSubRows(row);
  }
  function getItemGroup(item) {
    if (!props.groupProp || !props.groups || !props.groups.length) {
      return null;
    }
    return props.groups.find((group) => group.id === item[props.groupProp]);
  }
  return {
    displayHeaders,
    canBeExpanded,
    tableMaxHeightStyle,
    displayWithMobileExpand,
    getItemGroup
  };
}
